import { Env, readFromEnv } from '@cinch-nx/environments'

export const getNaturalLanguageQueryFromUrlPath = (
  urlPath: string,
  isAiSearchVariant = false,
): string | null => {
  const isNaturalLanguageSearchEnabled =
    readFromEnv(Env.EnableNaturalLanguageSearch) === 'true' && isAiSearchVariant

  if (!isNaturalLanguageSearchEnabled) {
    return null
  }

  const urlWithoutLeadingSlash = urlPath.startsWith('/')
    ? urlPath.slice(1)
    : urlPath

  return new URLSearchParams(urlWithoutLeadingSlash.split('?')[1]).get('q')
}
